import { appColors, Tier } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { View, Text, StyleSheet } from '@react-pdf/renderer';

import { CareerPathDiagramPDF } from '../molecules/CareerPathDiagramPDF/CareerPathDiagramPDF';

const MINIMUM_TRACK_STRINGS = appStrings.modules.results;

type MinimumTrackExplanationPDFProps = Readonly<{
  minimumTrack: Tier;
  entrepreneurshipRecommended: boolean;
}>;

export const MinimumTrackExplanationPDF = ({
  minimumTrack,
  entrepreneurshipRecommended,
}: MinimumTrackExplanationPDFProps) => {
  const { aspirationsIndicate, description, entrepreneurshipText } =
    MINIMUM_TRACK_STRINGS[minimumTrack];

  return (
    <View style={styles.container}>
      <View>
        <Text style={styles.chip}>
          <Text style={styles.headerChipText}>
            {MINIMUM_TRACK_STRINGS.minTrackExplanationHeader}
          </Text>
        </Text>
        <View style={styles.minimumTrackHeaderContainer}>
          <Text style={styles.bodyText}>{aspirationsIndicate}</Text>
          <CareerPathDiagramPDF
            minimumTrack={minimumTrack}
            entrepreneurshipRecommended={entrepreneurshipRecommended}
          />
        </View>
        <Text style={styles.description}>
          {description}
          {entrepreneurshipRecommended ? entrepreneurshipText : ''}
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  minimumTrackHeaderContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    position: 'relative',
  },
  headerChipText: {
    fontSize: 11,
    color: appColors.color.blue1,
    fontWeight: 'bold',
  },
  container: {
    backgroundColor: appColors.neutral.white,
    border: `1px solid ${appColors.neutral.black}`,
    borderRadius: 8,
    padding: 16,
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  chip: {
    backgroundColor: appColors.color.blue7,
    padding: 5,
    paddingHorizontal: 10,
    alignSelf: 'flex-start',
    borderRadius: 3,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    marginBottom: 4,
  },
  bodyText: {
    fontSize: 10,
    width: '60%',
    position: 'absolute',
    left: 0,
    top: 0,
  },
  description: {
    fontSize: 10,
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
    marginTop: 240,
  },
});
